import { Dialog, DialogContent } from "~/components/ui/dialog";
import { Spinner } from "~/components/ui/spinner";

interface DeviceRouteLoadingDialogProps {
  onOpenChange: () => void;
}

export const DeviceRouteLoadingDialog = ({
  onOpenChange,
}: DeviceRouteLoadingDialogProps) => {
  return (
    <Dialog onOpenChange={onOpenChange} open>
      <DialogContent>
        <div className="flex items-center justify-center py-8">
          <Spinner className="size-6" />
        </div>
      </DialogContent>
    </Dialog>
  );
};
